import { render, staticRenderFns } from "./VideoLockedComponent.vue?vue&type=template&id=8a18c710&scoped=true"
import script from "./VideoLockedComponent.vue?vue&type=script&lang=js"
export * from "./VideoLockedComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a18c710",
  null
  
)

export default component.exports